var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{attrs:{"padding":""}},[_c('header-creative'),_c('list-creative'),_c('edit-creative',{attrs:{"id":_vm.idCreative}}),_c('tag-creative',{attrs:{"id":_vm.idCreativeTag}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }